import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _regeneratorRuntime from "@babel/runtime/regenerator";
var WebVitalsObserver = /*#__PURE__*/function () {
  function WebVitalsObserver() {
    _classCallCheck(this, WebVitalsObserver);
    _defineProperty(this, "data", {
      'metric:ttci': null,
      'metric:ttfb': null,
      'metric:fid': null,
      'metric:fcp': null,
      'metric:lcp': null,
      'metric:cls': null
    });
  }
  return _createClass(WebVitalsObserver, [{
    key: "start",
    value: function start() {
      this.ttciDetermined = this.registerTTCI();
      this.webVitalsDetermined = this.registerWebVitals();
    }
  }, {
    key: "registerWebVitals",
    value: function () {
      var _registerWebVitals = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var _this = this;
        var _yield$import, getCLS, getFCP, getFID, getLCP, getTTFB;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return import( /* webpackChunkName: "web-vitals" */
              'web-vitals');
            case 3:
              _yield$import = _context.sent;
              getCLS = _yield$import.getCLS;
              getFCP = _yield$import.getFCP;
              getFID = _yield$import.getFID;
              getLCP = _yield$import.getLCP;
              getTTFB = _yield$import.getTTFB;
              _context.next = 11;
              return Promise.all([getTTFB, getFID, getFCP, getLCP, getCLS].map(function (fx) {
                return new Promise(function (resolve) {
                  fx(function (_ref) {
                    var name = _ref.name,
                      value = _ref.value;
                    // round FCP, FID, LCP, TTFB to nearest integer.
                    // CLS is rounded to two decimal places.
                    var metricName = name.toLowerCase();
                    var metricValue = metricName === 'cls' ? parseFloat(value.toFixed(2)) : Math.round(value);
                    _this.data["metric:".concat(metricName)] = metricValue;
                    resolve();
                  });
                });
              }));
            case 11:
              _context.next = 15;
              break;
            case 13:
              _context.prev = 13;
              _context.t0 = _context["catch"](0);
            case 15:
            case "end":
              return _context.stop();
          }
        }, _callee, null, [[0, 13]]);
      }));
      function registerWebVitals() {
        return _registerWebVitals.apply(this, arguments);
      }
      return registerWebVitals;
    }()
  }, {
    key: "registerTTCI",
    value: function () {
      var _registerTTCI = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var _this2 = this;
        var ttiPolyfill;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              _context2.next = 3;
              return import( /* webpackChunkName: "tti-polyfill" */
              'tti-polyfill');
            case 3:
              ttiPolyfill = _context2.sent;
              _context2.next = 6;
              return ttiPolyfill.getFirstConsistentlyInteractive().then(function (value) {
                // according to the docs:
                // If no TTI value can be found, or if the browser doesn't support all the APIs required to detect TTI,
                // the promise resolves to null.
                _this2.data['metric:ttci'] = typeof value === 'number' ? Math.round(value) : value;
                return true;
              });
            case 6:
              _context2.next = 10;
              break;
            case 8:
              _context2.prev = 8;
              _context2.t0 = _context2["catch"](0);
            case 10:
            case "end":
              return _context2.stop();
          }
        }, _callee2, null, [[0, 8]]);
      }));
      function registerTTCI() {
        return _registerTTCI.apply(this, arguments);
      }
      return registerTTCI;
    }()
  }]);
}();
export var webVitalsObserver = new WebVitalsObserver();